import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, parts } from './content/readingWriting';

export default function ReadingWriting() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="Everything in the Reading and Writing section: craft and structure, information and ideas, standard English conventions, and expression of ideas."
      parts={parts}
      tabbed
    />
  );
}
